import React from 'react';

export const AudioThumbnail: React.FC<{ className?: string; width?: number }> = ({
  className,
  width = 358
}) => {
  return (
    <svg
      width={width}
      height={(width * 62) / 358}
      viewBox='0 0 358 62'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask id='path-1-inside-1_8025_322726' fill='white'>
        <path d='M0 8C0 3.58172 3.58172 0 8 0H44V62H8C3.58172 62 0 58.4183 0 54V8Z' />
      </mask>
      <path d='M0 8C0 3.58172 3.58172 0 8 0H44V62H8C3.58172 62 0 58.4183 0 54V8Z' fill='#48484A' />
      <path
        d='M0 0H44H0ZM44 62H0H44ZM0 62V0V62ZM46 0V62H42V0H46Z'
        fill='#272727'
        mask='url(#path-1-inside-1_8025_322726)'
      />
      <path
        d='M29.75 29.701C30.75 30.2784 30.75 31.7218 29.75 32.2991L16.25 40.0933C15.25 40.6707 14 39.949 14 38.7943L14 23.2058C14 22.0511 15.25 21.3295 16.25 21.9068L29.75 29.701Z'
        fill='#D1D1D6'
      />
      <path
        d='M44 0H350C354.418 0 358 3.58172 358 8V54C358 58.4183 354.418 62 350 62H44V0Z'
        fill='#272727'
      />
      <path d='M48 23L48 39' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M52 12L52 50' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M56 23L56 39' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M60 23L60 39' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M64 18L64 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M68 18L68 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M72 21L72 41' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M76 18L76 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M80 27L80 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M84 18L84 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M88 18L88 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M92 23L92 39' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M96 12L96 50' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M100 12L100 50' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M104 23L104 39' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M108 18L108 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M112 12L112 50' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M116 23L116 39' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M120 27L120 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M124 23L124 39' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M128 27L128 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M132 27L132 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M132 18L132 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M136 18L136 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M140 25L140 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M144 25L144 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M148 25L148 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M152 18L152 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M156 18L156 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M160 13L160 49' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M164 25L164 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M168 25L168 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M172 18L172 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M176 25L176 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M180 25L180 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M184 25L184 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M188 18L188 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M192 20L192 42' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M196 18L196 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M200 23L200 39' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M204 18L204 44' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M208 13L208 49' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M215 27L215 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M219 24L219 38' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M223 27L223 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M227 27L227 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M231 14L231 48' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M235 22L235 40' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M239 22L239 40' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M243 14L243 48' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M247 24L247 38' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M251 27L251 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M255 27L255 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M259 22L259 40' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M263 14L263 48' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M267 27L267 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M271 27L271 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M275 27L275 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M279 25L279 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M283 27L283 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M287 27L287 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M291 27L291 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M295 24L295 38' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M299 27L299 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M303 27L303 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M307 27L307 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M311 25L311 37' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M315 27L315 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M319 27L319 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M323 27L323 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M327 27L327 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M331 22L331 40' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M335 27L335 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M339 22L339 40' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M343 14L343 48' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M347 24L347 38' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
      <path d='M351 27L351 35' stroke='#636366' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};

export default AudioThumbnail;
